import React, { Component } from "react";
import { Button } from 'antd';
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
        }
    }
    componentDidMount(){
    }
    
    goQuery2(){
        this.props.history.push({ pathname: "/home/info2", state: {} });
    }

    render()
    {
        return (
            <div data-component="info">
                <div class="sg-info-view">
                    <div className="sg-info-title">电子营业执照使用操作指南</div>
                    <div className="sg-info-title2">（未领取电子营业执照）</div>
                    <div className="sg-info-font" style={{marginTop:'0.3rem'}}>注:首次领取手机版电子营业执照，必须由法定代表人通过手机等移动终端完成。法定代表人领取手机版电子营业执照后，可自行或授权证照管理人员保管、持有、使用电子营业执照。法定代表人或者证照管理人员可授权办事人持电子营业执照办理相关的政务、商务、公共服务等业务，授权事项请选择“电子政务-市场监管 统一身份认证”。证照管理员和办事人经过授权后可下载电子营业执照并使用。</div>
                    <div className="sg-info-font">1、请使用微信或支付宝扫描登录二维码，打开电子营业执照小程序，或进入电子营业执照小程序使用“扫一扫”扫描登录二维码。</div>
                    <div className="sg-info-font">2、点击“下载执照”，录入姓名、身份证号等信息进行实名认证，如果实名认证不通过，需要到当地的市场监督部门扫码下载电子营业执照。</div>
                    <div className="sd-spaceBetween">
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/1.jpg')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/2.png')} />
                        </div>
                    </div>
                    <div className="sd-spaceBetween">
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/3.png')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/4.jpg')} />
                        </div>
                    </div>
                    <div className="sg-info-font">3、通过实名认证后，选择企业所在的登记地，显示该登记地的所有可下载和已下载的执照记录，在“可下载执照记录,中选择企业名称，下载该企业的电子营业执照。</div>
                    <div className="sd-spaceBetween">
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/5.png')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/6.jpg')} />
                        </div>
                    </div>
                    <div className="sg-info-font">4、下载电子营业执照前，需要阅读并同意《执照下载声明》。如果在本APP上修改过密码，下载时需要输入修改后的密码。</div>
                    <div className="sg-info-font">5、执照下载成功后，可以继续下就其他的执照，也可以修改本手机当前APP已经下载的所有执照的密码，或者返回主页进行其他的操作。</div>
                    <div className="sd-spaceBetween">
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/7.jpg')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/8.jpg')} />
                        </div>
                    </div>
                    <div className="sg-info-font">6、返回电子营业执照主页，点击”扫一扫”扫描申报系统的登录二维码，选择电子营业执照进行验证，验证通过后，点击”确认登录，即可在电脑端登录该企业。</div>
                    <div className="sd-spaceBetween">
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/9.jpg')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/10.jpg')} />
                        </div>
                    </div>
                    <div className="sd-spaceBetween">
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/11.jpg')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/screenshot/12.jpg')} />
                        </div>
                    </div>
                    <div className="sg-info-font"><Button type="link" className="sg-tips-line" style={{padding:0}} onClick={()=>{this.goQuery2()}}>点击此处了解更多电子营业执照使用信息。</Button></div>
                    <div className="sg-info-font">如需电话咨询，请进入电子营业执照小程序查看、拨打企业登记地技术支持电话。</div>
                </div>
            </div>
        )
    }
}

export default Index
